import undefinity from "../../common/helpers/undefinity";
import Photo from "../../api/types/Photo";

export default function normalizePhoto(photo: Photo) {
    return {
        photos: {
            [photo.id]: undefinity({...photo})
        }
    }
}